// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1KQF_","title":"InfoRow_title__3HsAc"};